<!-- 扫码签到 -->
<template>
  <div class="container">
    <a-button type="primary" @click="scanIt">扫一扫</a-button>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      formData: {
        alias: this.$route.query.alias,
        signId: this.$route.query.configuration,
        signMode: "ScanCode",
        scanField: "",
      },
    };
  },
  computed: {
    ...mapState("scanStore", ["scannedCode"]),
  },
  mounted() {
    if (this.scannedCode) {
      this.formData.scanField = this.scannedCode;
      this.clearScannedCode();
      this.$emit("search", this.formData);
    }
    // this.$eventBus.$on("scan", (emitData) => {
    //   this.formData.scanField = emitData.text;
    //   this.$parent.emitSearch(this.formData);
    //   // this.$emit("search", this.formData);
    // });
  },
  methods: {
    ...mapMutations("scanStore", ["clearScannedCode"]),
    // 打开扫一扫
    scanIt() {
      this.clearScannedCode();
      this.$router.push({ path: "/scan" });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
